import PasswordHasBeenCreated from './PasswordHasBeenChanged';

export default PasswordHasBeenCreated;